import request from '@/config'
import { CompanyDtoBase, CompanySearchDto, CompanyDeleteDto } from './dtos'

enum Apis {
    'Create' = `/api/bascompany/insertbascompany`,              // 创建公司数据
    'Modify' = `/api/bascompany/updatebascompany`,              // 修改公司数据
    'List' = `/api/bascompany/getbascompanypage`,
    'Detail' = `/api/bascompany/getbascompanyinfo`,
    'Delete' = `/api/bascompany/deletebascompany`,
    'DropdownList' = `/api/bascompany/getcompanydropdownlist`,
}

const GetCompanyListApi = (search: CompanySearchDto): Promise<IResponse> => {
    return request.post({ url: Apis.List, data: search })
}

const GetCompanyDetailApi = (rowId: string): Promise<IResponse> => {
    return request.post({ url: Apis.Detail, data: { id: rowId } })
}

const GetCompanyDpListApi = (): Promise<IResponse> => {
    return request.post({ url: Apis.DropdownList, data: {} })
}

const CreateCompanyApi = (input: CompanyDtoBase): Promise<IResponse> => {
    return request.post({ url: Apis.Create, data: input })
}

const ModifyCompanyApi = (input: CompanyDtoBase): Promise<IResponse> => {
    return request.post({ url: Apis.Modify, data: input })
}

const CompanyDeleteApi = (input: CompanyDeleteDto): Promise<IResponse> => {
    return request.post({ url: Apis.Delete, data: input })
}

export {
    CreateCompanyApi,
    ModifyCompanyApi,
    GetCompanyListApi,
    GetCompanyDetailApi,
    CompanyDeleteApi,
    GetCompanyDpListApi,
}

